import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';

/**
 * Confirms putting a published workflow's draft live (spec 144 FR-004).
 *
 * A modal for the same reason `PublishDialog` is one: this reaches work
 * already under way. Unlike the first publish, the thing worth saying is not
 * what becomes fixed but who feels it — the tasks running on this workflow,
 * which continue on the new version the moment it is confirmed (Q12).
 */
export function PublishChangesDialog({
  workflowName,
  open,
  isPending,
  onOpenChange,
  onConfirm,
}: {
  workflowName: string;
  open: boolean;
  isPending: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
}) {
  return (
    <Dialog
      open={open}
      onOpenChange={(next) => {
        // Closing mid-flight would leave the result landing nowhere.
        if (isPending) return;
        onOpenChange(next);
      }}
    >
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Publish changes to {workflowName}?</DialogTitle>
          <DialogDescription>
            Tasks already running on this workflow continue on the new version.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <DialogClose
            render={<Button variant="outline" disabled={isPending} />}
          >
            Cancel
          </DialogClose>
          <Button onClick={onConfirm} disabled={isPending}>
            {isPending ? 'Publishing…' : 'Publish changes'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
